$(document).ready(function () {

  body.delegate(".product-links.constructor-type-1", "click", function (b) {
    b.preventDefault();
    if (!empty) {
      $("#const-products").find("li").removeClass("active-inner");
      $(this).parent().addClass("active-inner");
      $.post(route_set_product, {product: $(this).data("value"), border: $("#const-borders").find(".active-inner").find("a").data("value")}, updateProduct, "json")
    } else $("#constructor-menu").find(".active .constructor-menu-close").trigger("click")
  });

});